// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-new{position:relative;display:block}.grid-new--smooth-resize{transition:height 350ms ease-in-out;overflow:hidden}", ""]);
// Exports
module.exports = exports;
